import { TCarouselSwiper, TSwiper } from 'widgets/global/CarouselSwiper';

import { getViewType, SMALL, MEDIUM, LARGE, EXTRA_LARGE } from 'widgets/toolbox/viewtype';

type TOption = ReturnType<InstanceType<TCarouselSwiper>['getOptions']> & {
    effect?: string;
    fadeEffect?: {
        crossFade?: boolean;
    };
};

type TFootbedSwiper = TSwiper & {
    on: (event: string, callback: () => void) => void;
    activeIndex?: number;
    slides: NodeListOf<HTMLElement>;
};

function FootbedCarouselClassCreator(CarouselSwiper: TCarouselSwiper) {
    class FootbedCarousel extends CarouselSwiper {
        prefs() {
            return {
                ...super.prefs(),
                loop: false,
                slidesPerView: 1,
                slidesPerViewTablet: 1,
                slidesPerViewDesktop: 1.7,
                scrollbarClass: '.swiper-scrollbar',
                scrollbarHide: false,
                centeredSlides: true,
                navPrevButton: '.slick-prev',
                navNextButton: '.slick-next'
            };
        }

        getOptions() {
            const prefs = this.prefs();
            const baseOptions = super.getOptions();

            let mergedOptions = {
                ...baseOptions,
                scrollbar: {
                    el: prefs.scrollbarClass,
                    hide: prefs.scrollbarHide
                }
            } as TOption;

            if (getViewType() === SMALL || getViewType() === MEDIUM) {
                mergedOptions = {
                    ...mergedOptions,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    }
                };
            } else {
                mergedOptions.breakpoints[1180] = {
                    loop: prefs.loop,
                    slidesPerView: prefs.slidesPerViewDesktop,
                    centeredSlides: prefs.centeredSlides
                };
            }

            return mergedOptions;
        }

        getElement() {
            const carousel = this.ref('self').get()?.querySelector('.main-slick-footbed-carousel');

            return carousel instanceof HTMLElement ? carousel : undefined;
        }

        afterActivate() {
            if (getViewType() === LARGE || getViewType() === EXTRA_LARGE) {
                this.renderCurrentSlidePanel();

                (this.swiper as TFootbedSwiper).on('slideChange', () => {
                    this.renderCurrentSlidePanel();
                });
            }
        }

        /**
         * @description Render current slide panel with details for desktop view
         */
        renderCurrentSlidePanel() {
            const footbedSwiper = this.swiper as TFootbedSwiper;
            const currentSlide = footbedSwiper?.slides[footbedSwiper?.activeIndex ?? 0];
            const descPanel = this.ref('self').get()?.querySelector('.list-item-details-wrapper');

            if (!currentSlide || !descPanel) {
                return;
            }

            const currentSlideData = currentSlide.querySelector('.list-item-details')?.innerHTML;

            descPanel.innerHTML = currentSlideData ?? '';
        }
    }

    return FootbedCarousel;
}

export type TFootbedCarousel = ReturnType<typeof FootbedCarouselClassCreator>;

export type TFootbedCarouselInstance = InstanceType<TFootbedCarousel>;

export default FootbedCarouselClassCreator;
